import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output
} from '@angular/core';
import {
  NG_VALUE_ACCESSOR,
  FormBuilder,
  FormGroup,
  Validators,
  ValidatorFn,
  AbstractControl
} from '@angular/forms';
import { Router } from '@angular/router';

type InputTypes =
  | 'text'
  | 'password'
  | 'email'
  | 'money'
  | 'date'
  | 'datetime-local'
  | 'number'
  | 'mask'
  | 'select'
  | 'select-table'
  | 'search'
  | 'disabled'
  | 'textarea'
  | 'month'
  | 'only-text';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputComponent),
      multi: true
    }
  ]
})
export class InputComponent implements OnInit {
  @Input() type: InputTypes = 'text';
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() readOnly: boolean = false;
  @Input() disabled: boolean = false;
  @Input() maxLength: string | null = null;
  @Input() width: string = '';
  @Input() mask: string = '';
  @Input() name: string = '';
  @Input() min: number | null = null;
  @Input() max: number | null = null;
  @Input() adultOnly: boolean = false;
  @Input() minAgeYears: number = 18;
  @Input() requiredInput: boolean = false;
  @Input() selectData: any[] = [];
  @Input() ngModel: any;
  @Output() ngModelChange: EventEmitter<any> = new EventEmitter();
  @Output() blurEvent: EventEmitter<void> = new EventEmitter();
  @Input() somenteDataFutura: boolean = false;
  passwordType: string = 'password';
  eyeImage: string = 'assets/eye-icon.png';

  value: any = '';

  onChange: any = () => {};
  onTouched: any = () => {};

  ngOnInit(): void {
    if (this.maxLength === '') {
      this.maxLength = null;
    }

    if (
      (this.type === 'select' && this.value === '') ||
      (this.type === 'select-table' && this.value === '')
    ) {
      this.value = '';
      this.onSelectChange(this.value);
    }
  }

  constructor(private router: Router) {}
  getMaxBirthDate(): string {
    const d = new Date();
    d.setFullYear(d.getFullYear() - (this.minAgeYears ?? 18));

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  togglePassword() {
    this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
    this.eyeImage = 'assets/eye-icon.png';
  }

  onSelectChange(value: any) {
    this.value = value === '' ? null : value;
    this.ngModelChange.emit(value);
  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.readOnly = isDisabled;
    this.disabled = isDisabled;
  }

  onValueChange(value: string | any) {
    if (typeof value === 'string' || typeof value === 'number') {
      this.value = value;
      this.onChange(this.value);
      this.onTouched();
    }

    this.ngModelChange.emit(this.value);
  }

  onFocus() {
    this.onTouched();
  }

  onBlur() {
    this.onTouched();
    this.blurEvent.emit();
  }

  onDateNow() {
    const date = new Date();
    return date.toISOString().slice(0, 16);
  }

  applyMask(event: KeyboardEvent): void {
    const key = event.key;
    const regex = /^[a-zA-ZÀ-ÿ\\s ]*$/;
    if (!regex.test(key)) {
      event.preventDefault();
    }
  }
  getNowDateTime(): string {
  const now = new Date();

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');

  return `${year}-${month}-${day}T${hours}:${minutes}`;
}

  /** yyyy-MM-dd (hoje, fuso local) — usado como [min] em type="date" com somenteDataFutura. */
  getTodayDateString(): string {
    const now = new Date();
    const y = now.getFullYear();
    const m = String(now.getMonth() + 1).padStart(2, '0');
    const d = String(now.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }
}
